import { Card } from 'react-bootstrap';

export default function BUSD() {
  return <div>
    <Card>
      <Card.Body>
        <Card.Title>BUSD</Card.Title>
        <Card.Text>
          Not available for testnet
        </Card.Text>
      </Card.Body>
    </Card>
  </div>
}